import {Component, OnInit} from '@angular/core';
import {APIHelper} from "../../../apihelper";
import {SharedResources} from "../../../shared-resources";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  isLoading: boolean = false;
  currentScreen:  string = '';
  username: any = '';

  constructor() {
  }

  ngOnInit(): void {
    this.username = localStorage.getItem('username');
    this.currentScreen = SharedResources.currentScreen;
    SharedResources._isLoadingBS.subscribe((data: boolean) => {
      this.isLoading = data;
    });
    SharedResources._currentScreenBS.subscribe((data: string) => {
      this.currentScreen = data;
    })
  }

  logout() {
    localStorage.setItem('token', '');
    localStorage.setItem('isAuth', 'false');
    this.username = '';
    APIHelper._tokenBS.next('');
    APIHelper._isAuthBS.next(false);
  }

  changeScreenToProducts() {
    SharedResources.currentScreen = 'products';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  changeScreenToOrders() {
    SharedResources.currentScreen = 'orders';
    SharedResources._currentScreenBS.next(SharedResources.currentScreen);
  }

  changePassword() {
    SharedResources.currentScreen = 'changePassword';
    SharedResources._currentScreenBS.next('changePassword');
  }
}
